import { render } from "./VideoGuideModal.vue?vue&type=template&id=4b133367&scoped=true"
import script from "./VideoGuideModal.vue?vue&type=script&lang=js"
export * from "./VideoGuideModal.vue?vue&type=script&lang=js"

import "./VideoGuideModal.vue?vue&type=style&index=0&id=4b133367&scoped=true&lang=css"
import "./VideoGuideModal.vue?vue&type=style&index=1&id=4b133367&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b133367"]])

export default __exports__